require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./service-datascience-business-architecture-datascience.json") })
        }
      }, "path---service-datascience-business-architecture-datascience");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---service-datascience-business-architecture-datascience!./.cache/json/service-datascience-business-architecture-datascience.json
// module id = 896
// module chunks = 231608221292675